import React, { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import {  ViewModelForm } from 'gw-portals-viewmodel-react';
import { DropdownSelectField, InputField } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';

import metadata from './AdditionalInterestTable.metadata.json5';

function AdditionalInterestTable(props) {
    
    const { submissionVM, updateWizardData, coverableVM, path, schedulesPath } = props;
    const translator = useContext(TranslatorContext);
    const [scheduleItems, updateScheduleItems] = useState([]);
    const [isPageLoaded, setIsPageLoaded] = useState(false);

    useEffect(()=>{
        if(!isPageLoaded){
            const availableValues = _.get(submissionVM, schedulesPath).value.map((item)=>{
                if(item.id){
                    item['defaultMessage'] = item.name;
                    return item;
                } else {
                    return {
                        id: item,
                        defaultMessage: item,
                        name: item
                    }
                }            
            })
            updateScheduleItems(availableValues);
            // _.each(_.get(submissionVM, `${path}.additionalInterests.children` ), (item) => {
            //     item.isScheduleItemValidationRequired = availableValues.length > 0;
            // });
            // updateWizardData(submissionVM);
            setIsPageLoaded(true)
        }
    },[submissionVM, scheduleItems, updateScheduleItems])

    const getCell = (item, index, property) => {
        const _path = property.id;
        const value = item.scheduleItemPublicID;        
        return (
            <DropdownSelectField
                id={index + _path}
                dataType="string"
                value={value}
                onValueChange={(_value)=>{
                    item.scheduleItemPublicID = _value;
                    _.set(submissionVM, `${path}.additionalInterests.children.${index}.scheduleItemPublicID.value`, _value)
                    updateWizardData(submissionVM);
                }}
                availableValues={scheduleItems}
                searchable={true}
                alwaysShowPlaceholder={true}
            />
        )
    }

    const getScheduleItemHeader = () => {
        return <div>{'Schedule Items'} </div>
    };

    const getDescription = (item, index, property) => {        
        const _path = property.id;
        const value = item.description;
        return (
            <InputField
                id={index + _path}
                dataType="string"
                value={value}
                onValueChange={(_value)=>{
                    item.description = _value;
                    _.set(submissionVM, `${path}.additionalInterests.children.${index}.description.value`, _value)
                    updateWizardData(submissionVM);
                }}
            >
            </InputField>
        )
    }

    const getInterestType = (item, index, property) => {
        //return translator({id: `typekey.AdditionalInterestType.${item.type}`})
        const _path = property.id;
        const value = item.type; 
        const availableValues =  _.get(submissionVM, `${path}.additionalInterests.children.${index}.type`).aspects.availableValues.map((aiType)=>{
            return {
                code: aiType.code,
                name: translator({id: aiType.name})
            }
        });      
        return (
            <DropdownSelectField
                id={index + _path}
                dataType="string"
                value={value}
                onValueChange={(_value)=>{
                    item.type = _value;
                    _.set(submissionVM, `${path}.additionalInterests.children.${index}.type.value`, _value)
                    updateWizardData(submissionVM);
                }}
                availableValues={availableValues}
                searchable={true}
                readOnly={true}
            />
        )
    }
  
    const overrideProps = {
        additionalInterestTable:  {
            title: 'Additional Interests',
            visible: coverableVM.additionalInterests.children.length > 0 && scheduleItems.length > 0
        }
    };

    const resolvers = {
        resolveCallbackMap:{
            getCell: getCell,
            getInterestType: getInterestType,
            getDescription: getDescription,
            getScheduleItemHeader: getScheduleItemHeader
        }
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={coverableVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}


export default AdditionalInterestTable;
